<script lang="ts">
    import {pipe} from 'core/utils';
    import {characters} from 'shared/utils/pipes';
    import {getLocalization, getSanitize} from 'core/svelte-context/context';

    export let charactersLimit: number;
    export let value: string;

    const localize = getLocalization();
    const htmlSanitize = getSanitize();

    let collapsed = true;
    $: collapsible = value.length > charactersLimit;

    const handleToggleClick = () => {
        collapsed = false;
    }
</script>

<span>
    {#if collapsible && collapsed}
        <span>
            {pipe(htmlSanitize(value), characters(charactersLimit))}
            <button class="unset-style show-all-btn" type="button" on:click={handleToggleClick}>
                {localize(/* @kp-localization commons.ZobrazitVse */ 'commons.ZobrazitVse')}
            </button>
        </span>
    {:else}
        <span>{@html htmlSanitize(value)}</span>
    {/if}
</span>

<style lang="less">
    .show-all-btn {
        color: var(--accent-blue-new);
        cursor: pointer;

        &:hover {
            text-decoration: underline;
        }
    }
</style>